'use strict';

angular.module('msCommunity').service('discussionSvc', ['httpSvc', '$q', 'activitySvc', 'widgetSvc', 'notificationSvc', 'NotifyingSvc', function (httpSvc, $q, activitySvc, widgetSvc, notificationSvc, NotifyingSvc) {
  // we keep a cached version of all the topics - they're expensive to fetch & process
  var topicsCache;

  NotifyingSvc.subscribe(NotifyingSvc.EVENTS.OPTIN_UPDATE, function () {
    topicsCache = null;
  });

  function post(discussion) {
    return httpSvc.post('/apiproxy/user/discussion', discussion).then(function (resp) {
      notificationSvc.refresh();
      return resp;
    });
  }

  function flag(commentId, flagType) {
    return httpSvc.post('/apiproxy/user/discussion/flags/' + commentId, '"' + flagType + '"').then(function (resp) {
      notificationSvc.refresh();
      return resp;
    });
  }

  function unflag(commentId) {
    return httpSvc.delete('/apiproxy/user/discussion/flags/' + commentId);
  }

  /**
   * Get all of the activities in a topic, along with their primary discussion item.
   * @param  {string} tag the topic to get discussions for
   * @return {array}     array of activities with their discussion comments
   */
  function getTopic(tag) {
    return $q.all([activitySvc.getActivitiesByTag(tag), _getDiscussions()]).then(function (data) {
      var activities = data[0];
      var discussions = data[1];
      // filter out any categories without discussions
      return _addDiscussions(activities, discussions);
    });
  }

  function getTopics() {
    if (topicsCache) {
      return $q.when(topicsCache);
    }
    // get all the categories & discussions to merge together
    return $q.all([activitySvc.getTags(true), _getDiscussions()]).then(function (data) {
      var categories = data[0];
      var discussions = data[1];
      // filter out any categories without discussions
      categories = categories.filter(function (category) {
        // filter out any activities without discussions
        category.activities = _addDiscussions(category.activities, discussions);
        return category.activities.length > 0;
      });
      // add the "all" category
      categories.unshift(_getAllCategory(categories));
      topicsCache = categories;
      return categories;
    });
  }

  function _addDiscussions(activities, discussions) {
    return activities.filter(function (activity) {
      // find the discussion for this activity
      var activityDiscussions = discussions.filter(function (discussion) {
        return discussion.topic === activity.url;
      });
      // if we found a discussion, add it to the activity
      if (activityDiscussions.length > 0) {
        activity.discussion = activityDiscussions[0];
      }
      // filter out this activity if it didn't have a discussion
      return activityDiscussions.length > 0;
    });
  }

  function _getAllCategory(categories) {
    return {
      shortName: 'ALL',
      label: 'All Tags',
      activities: categories.reduce(function (a, b) {
        // mash all the categories activities into one list
        return a.concat(b.activities.filter(function (l) {
          // don't include this activity if it's already in the all list
          return a.filter(function (m) {
            return m.url === l.url;
          }).length === 0;
        }));
      }, [])
    };
  }

  function _getDiscussions() {
    return httpSvc.get('/apiproxy/user/discussion');
  }

  function getActivityDiscussions(activityShort) {
    var promises = [_getActivity(activityShort), _getDiscussionsByActivity(activityShort)];
    // fetch both the full activity & the discussions
    return $q.all(promises).then(function (data) {
      // data[0] == activity, data[1] == related discussions
      var activity = data[0];
      activity.discussions = _assignChildren(data[1]);
      // put the actual widget instead of just it's UUID
      activity.promotedWidget = widgetSvc.getByUuid(activity, activity.promotedWidget);
      return activity;
    });
  }

  function _getDiscussionsByActivity(a) {
    return httpSvc.get('/apiproxy/user/discussion/' + a);
  }

  function _getActivity(a) {
    return httpSvc.get('/apiproxy/user/activities/' + a + '?include=sections');
  }

  // find all the parents and assign their children
  function _assignChildren(discussions) {
    return discussions.filter(function (c) {
      // filter to return only parents
      if (c.parentId === null) {
        // if no parent, this is a parent, so add children
        c.comments = discussions.filter(function (c2) {
          return c2.parentId === c.id;
        });
      }
      return c.parentId === null;
    });
  }

  function getComment(commentId) {
    return httpSvc.get('/apiproxy/user/discussion/comment/' + commentId).then(function (resp) {
      // assign comments, should only be one parent
      return _assignChildren(resp)[0];
    });
  }

  return {
    post: post,
    flag: flag,
    unflag: unflag,
    getTopics: getTopics,
    getTopic: getTopic,
    getActivityDiscussions: getActivityDiscussions,
    getComment: getComment
  };
}]);